import React from 'react';

import "./Extra1.css"

const Extra1 = () => {
    return (
        <div className="my-5">
            <h2 className="text-center fw-bold">OUR ADVANTAGES</h2>

            <div className="row row-cols-1 row-cols-md-4 g-4 w-75 m-auto">

                <div className="col col1">
                    <div className="card p-2 h-100">
                        <img src="https://livedemo00-joomla.template-help.com/joomla_prod-21623/templates/theme1588/images/home-icon1.png" className="card-img-top ccc" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">SUGGEST HELMATE</h5>
                            <p className="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                        </div>
                    </div>
                </div>
                <div className="col col1">
                    <div className="card p-2 h-100">
                        <img src="https://livedemo00-joomla.template-help.com/joomla_prod-21623/templates/theme1588/images/home-icon2.png" className="card-img-top ccc" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">SAVE OIL</h5>
                            <p className="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.

                            </p>
                        </div>
                    </div>
                </div>
                <div className="col col1">
                    <div className="card p-2 h-100">
                        <img src="https://livedemo00-joomla.template-help.com/joomla_prod-21623/templates/theme1588/images/home-icon3.png" className="card-img-top ccc" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">TRAVEL GUIDE</h5>
                            <p className="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                        </div>
                    </div>
                </div>
                <div className="col col1">
                    <div className="card p-2 h-100">
                        <img src="https://livedemo00-joomla.template-help.com/joomla_prod-21623/templates/theme1588/images/home-icon4.png" className="card-img-top ccc" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">DRIVING GUIDE</h5>
                            <p className="card-text">Although manual gearboxes are commonplace, automatic gearboxes are increasingly popular –and the art of driving a stick shift.</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Extra1;